import type { II18nConfiguration } from "@bbj-types/organisation";
import { PhoneNumberUtil } from "google-libphonenumber";

export const phoneUtil = PhoneNumberUtil.getInstance();
export const availableRegionCodes: II18nConfiguration["phoneCode"][] = ["FR", "GP", "GF", "RE", "MQ", "YT"];
export const getDialCode = (code: II18nConfiguration["phoneCode"]) => `+${phoneUtil.getCountryCodeForRegion(code)}`;

export const phoneCodeLabelMap: Record<II18nConfiguration["phoneCode"], string> = {
  FR: "France métropolitaine",
  GP: "Guadeloupe",
  GF: "Guyane",
  RE: "La Réunion",
  MQ: "Martinique",
  YT: "Mayotte",
};

export const countDigits = (str: string, end: number) => (str.slice(0, end).match(/\d/g) ?? []).length;

export const caretIndexAfterDigits = (str: string, digitCount: number) => {
  if (digitCount <= 0) {
    return 0;
  }
  let seen = 0;
  for (let i = 0; i < str.length; i++) {
    if (/\d/.test(str[i])) {
      seen++;
      if (seen === digitCount) {
        return i + 1;
      }
    }
  }
  return str.length;
};
